import { z } from 'zod/v4';
/** Fields of the canonical split-adjusted daily bar; rawClose is its scale evidence. */
export const PRICE_ISSUE_FIELDS = { open: 1, high: 2, low: 4, close: 8, volume: 16, rawClose: 32 };
export const ALL_PRICE_ISSUE_FIELDS = 63;
/** Entry input omissions only; post-entry outcome coverage is a separate denominator. */
export const researchEntryCoverageSummarySchema = z.object({
    /** One persisted asset/duration/session evaluation per completed entry unit. */
    excludedEvaluationCount: z.number().int().nonnegative(),
    affectedAssetCount: z.number().int().nonnegative(),
    firstSessionDate: z.string().nullable(),
    lastSessionDate: z.string().nullable(),
    /** Exact number of symbol/timeframe/reason groups, including omitted detail. */
    groupCount: z.number().int().nonnegative(),
    /** byAsset contains only the largest groups when this is true; totals always cover all groups. */
    truncated: z.boolean(),
    byAsset: z.array(z.object({
        assetId: z.number().int().positive(),
        symbol: z.string(),
        duration: z.string(),
        reason: z.enum(['invalidPrice', 'confirmedMissing', 'repairPending', 'unavailableRequiredEvidence']),
        excludedEvaluationCount: z.number().int().positive(),
        firstSessionDate: z.string(),
        lastSessionDate: z.string()
    }))
});
//# sourceMappingURL=MarketDataQuality.js.map